export default __webpack_public_path__ + "static/media/quad_instructions.ff773e17.mp3";